import { notifications } from "@mantine/notifications";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { appointmentService } from "..";

type CancelFromCalendar = {
  appointmentId: number;
  cancellationDescription?: string | null;
};

// The calendar knows the appointment, not its booking, so the booking (queue) is looked up first
// and cancelled through AppointmentQueue/Cancel, which also cancels an open SnappPay payment.
function useCancelAppointment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ appointmentId, cancellationDescription }: CancelFromCalendar) => {
      const appointmentQueueId = await appointmentService.getQueueIdByAppointmentId(appointmentId);
      if (!appointmentQueueId) throw new Error("نوبت یافت نشد");
      return appointmentService.cancelAppointmentQueue({ appointmentQueueId, cancellationDescription });
    },
    onSuccess: () => {
      // Remove the cancelled booking from the calendar and the online bookings report without a reload.
      queryClient.invalidateQueries({ queryKey: ["getDailyAppointment"] });
      queryClient.invalidateQueries({ queryKey: ["getAppointmentDeposit"] });
    },
    onError: (error) => {
      // Server errors are already shown by the axios interceptor.
      if (!isAxiosError(error)) notifications.show({ color: "red", message: (error as Error).message });
    },
  });
}

export default useCancelAppointment;
